/** A short UPPER_SNAKE token, the shape of every code person-api names for a confirmation 409. */
const CODE_TOKEN = /^[A-Z][A-Z0-9_]{0,39}$/;

/** The marker for a code that is present but is not a short UPPER_SNAKE token. */
const UNKNOWN_CODE = 'unknown';

/** The marker for a refusal that arrived with no code. */
const NO_CODE = 'none';

/**
 * The code to report to New Relic (Greengate-Fintech/verifime-adr#690): the code when it is a short
 * UPPER_SNAKE token, else a fixed marker. Free text never reaches the report, because a server can
 * put anything in a code. Both markers are lower case, so neither can be mistaken for a code.
 */
function sanitisedCodeOf(errorCode: unknown): string {
  if (errorCode === undefined || errorCode === null || errorCode === '') {
    return NO_CODE;
  }
  return typeof errorCode === 'string' && CODE_TOKEN.test(errorCode) ? errorCode : UNKNOWN_CODE;
}

/**
 * The server refused the confirmation of an invite with a 409 the portal does not route: it carries
 * no `errorCode`, or one the portal does not know (Greengate-Fintech/verifime-adr#523 Q5, #682).
 * Thrown during render so the app-level `PortalErrorBoundary` shows, with no 409 copy. The message
 * names the case and carries no id. New Relic reports the name, and the boundary adds the
 * sanitised `errorCode`, so a report tells "no code" from "a code the portal does not know"
 * (#690).
 */
export class ConfirmationRefusedError extends Error {
  /** The code person-api sent if it is a short UPPER_SNAKE token, else `unknown`, or `none` if missing. */
  readonly errorCode: string;

  constructor(errorCode?: unknown) {
    super('The server refused the confirmation');
    this.name = 'ConfirmationRefusedError';
    this.errorCode = sanitisedCodeOf(errorCode);
  }
}
